// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide_Slide__1Fo3Q","Active":"Slide_Active__1LE3i","Content":"Slide_Content__4MHFn"};